<template>
  <component
    :is="tag"
    :contenteditable="!disabled"
    :placeholder="placeholder"
    class="content-editable"
    @blur="onInput"
    @keypress.enter.prevent
    v-text="value"
  />
</template>

<script>
export default {
  props: {
    value: String,
    disabled: Boolean,
    placeholder: {
      type: String,
      default() {
        return this.$t('typeHere') + '...'
      },
    },
    tag: {
      type: String,
      default: 'span',
    },
  },
  methods: {
    onInput(ev) {
      setTimeout(() => this.$emit('input', ev.target.innerText), 0)
    },
  },
}
</script>

<style lang="scss">
.content-editable {
  outline: none;

  &[placeholder]:empty::before {
    font-weight: normal;
    content: attr(placeholder);
    color: rgba(black, 0.3);
  }
}
</style>
